export default __webpack_public_path__ + "static/media/altered_down.facaf4e4.svg";